"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeInput = void 0;
const react_1 = __importDefault(require("react"));
const input_1 = __importDefault(require("@kyruus/input"));
const select_1 = __importDefault(require("@kyruus/select"));
const checkbox_1 = __importDefault(require("@kyruus/checkbox"));
const row_1 = __importDefault(require("../row"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const validateStringNumber_1 = require("../../../validation/validators/validateStringNumber");
const utils_1 = require("../../inputs/select-input/utils");
const checkbox_input_1 = require("../../inputs/checkbox-input");
const label_1 = __importDefault(require("../../label"));
const AgeInput = ({ age, ageUnit, unbounded }) => {
    const [ageState, ageActions] = (0, use_form_1.default)(age.path, {
        eventProcessor: (e) => e.target.value,
        validator: validateStringNumber_1.validateStringNumber
    });
    const [ageUnitState, ageUnitActions] = (0, use_form_1.default)(ageUnit.path, {
        type: ageUnit.type,
        eventProcessor: utils_1.getSerializedValue
    });
    const [unboundedState, unboundedActions] = (0, use_form_1.default)(unbounded.path, {
        eventProcessor: (checked) => checked
    });
    const handleAgeChange = (e) => {
        ageActions.onChange(e);
    };
    const handleUnboundedChange = (checked) => {
        if (checked) {
            // Clear all values if unbinding age
            handleAgeChange({ target: { value: '' } });
            ageUnitActions.onBlur(null);
            unboundedActions.onBlur(checked);
        }
        else {
            unboundedActions.onBlur(checked);
        }
    };
    return (react_1.default.createElement(row_1.default, { flexGrowSizes: [1, 1, 'none'], alignInputs: "baseline" },
        react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: Boolean(ageState.errors.length) },
            react_1.default.createElement(input_1.default, { errors: ageState.errors, onChange: handleAgeChange, onBlur: ageActions.onBlur, value: ageState.value, placeholder: ageState.config.placeholder, disabled: unboundedState.value, name: age.path, "data-testid": age.path, label: ageState.config.label || age.label || '', id: age.path, hideLabel: true, maxLength: ageState.config.maxLength, displayCharacterCount: ageState.config.displayCharacterCount, characterCountReachedMessage: ageState.config.characterCountReachedMessage })),
        react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: Boolean(ageUnitState.errors.length) },
            react_1.default.createElement("div", { className: "field-error-wrapper", "data-testid": `${ageUnit.path}-select-wrapper` },
                react_1.default.createElement(label_1.default, { id: `${ageUnit.path}-label`, visuallyHidden: true }, ageUnit.path),
                react_1.default.createElement(select_1.default, { id: ageUnit.path, errors: ageUnitState.errors, disabled: Boolean(unboundedState.value), useTypeahead: false, mode: 'dropdown', multiSelect: false, items: ageUnit.items, onChange: ageUnitActions.onChange, onInputValueChange: (value, status) => {
                        if (!status.isOpen) {
                            // takes care of "blur" when tabbing
                            ageUnitActions.onBlur(value);
                        }
                        else {
                            ageUnitActions.onChange(value);
                        }
                    }, placeholder: ageUnitState.config.placeholder, icon: "ArrowDown", showItemsOnClick: true, itemToString: utils_1.labelFromItem, onOuterClick: () => {
                        ageUnitActions.onBlur(ageUnitState.value);
                    }, maxHeight: 250, virtualized: false, "data-testid": ageUnit.path, initialSelectedItem: (0, utils_1.getDisplayValue)((0, utils_1.getSerializedValue)(ageUnitState.value), ageUnit.items) ||
                        (0, utils_1.getDisplayValue)((0, utils_1.getSerializedValue)(ageUnit.defaultSelection), ageUnit.items) }))),
        react_1.default.createElement(checkbox_input_1.FullHeight, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.FieldErrorWrapper, { errors: unboundedState.errors, style: { position: 'relative' } },
                    react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: !!unboundedState.errors.length },
                        react_1.default.createElement(checkbox_1.default, { disabled: unboundedState.config.isReadOnly, hasError: !!unboundedState.errors.length, isRequired: unboundedState.config.isRequired, checked: unboundedState.value, label: unbounded.label, onChange: handleUnboundedChange, dataTestId: unbounded.path, "aria-describedby": `${unboundedState.config.path}-errors`, "aria-invalid": unboundedState.errors.length > 0 }))),
                react_1.default.createElement("div", { id: `${unboundedState.config.path}-errors` }, unboundedState.errors.map((error, index) => (react_1.default.createElement(styles_1.ErrorMessage, { key: `${error}-${index}` }, error))))))));
};
exports.AgeInput = AgeInput;
//# sourceMappingURL=age-input.js.map